module.exports = __webpack_public_path__ + "static/media/banner-molinera.022e6297.jpg";